// extracted by mini-css-extract-plugin
export default {"content":"content_content__7DjTO","content_text":"content_content_text__2pI7k","m":"content_m__GpCTd","content_image":"content_content_image__jPVZu","p":"content_p__FMyy6"};